/**
 * inputDateSelectDirective
 *
 * @author Dec Norton <decnorton@gmail.com>
 */

import moment from 'moment';

inputDateSelectDirective.$inject = [];

export function inputDateSelectDirective() {
    return {
        // language=HTML
        template: `
            <div class="form-row">
                <app-input-text label="Year"
                                ng-if="isYearRecurring && !hideYear"
                                class="flex-33"
                                value="'Recurring'"
                                change="hasInteracted = true"
                                ng-disabled="true">
                </app-input-text>

                <app-input-number label="Year"
                                  ng-if="!isYearRecurring && !hideYear"
                                  class="flex-33"
                                  value="_value.year"
                                  change="hasInteracted = true"
                                  min="1900"
                                  max="2100">
                </app-input-number>

                <app-input-select label="Month"
                                  class="flex-33"
                                  value="_value.month"
                                  change="hasInteracted = true">

                    <md-option ng-repeat="month in months"
                               ng-value="month">
                        {{ month.format('MMMM') }}
                    </md-option>

                </app-input-select>

                <app-input-select label="Day"
                                  class="flex-33"
                                  ng-disabled="!days.length"
                                  value="_value.day"
                                  change="hasInteracted = true">

                    <md-option ng-repeat="day in days track by day"
                               ng-value="day">
                        {{ day.format('Do') }}
                    </md-option>

                </app-input-select>
            </div>

            <div ng-if="form && name" ng-messages="form[name].$error">
                <div ng-message="required">Required</div>
                <div ng-repeat="(key, message) in errorMessages" ng-message="{{ key }}">{{ message }}</div>
            </div>
        `,
        scope: {
            dispatchChange: '&?change',
            disabled: '=ngDisabled',
            errorMessages: '=errorMessages',
            label: '@?label',
            form: '=form',
            name: '@name',
            required: '=?required',
            value: '=?value',
            isYearRecurring: '=?isYearRecurring',
            hideYear: '=?hideYear',
        },
        link: function (scope, element, attrs) {
            element.addClass('app-form-field');

            const now = moment();

            scope.hasInteracted = false;

            scope._value = {
                month: null,
                day: null,
                year: now.year(),
            };

            scope.months = months();
            scope.days = {};

            // If it's undefined on the scope, it may mean that the attribute is there but
            // without content. If the attribute isn't undefined then we know it's been added.
            if (scope.required === undefined && attrs.required !== undefined) {
                scope.required = true;
            }


            // Watch for any changes to valueDate
            scope.$watch('_value.month', _monthWatcher);
            scope.$watch('_value', _valueWatcher, true);
            scope.$watch('value', valueWatcher, true);

            function valueWatcher() {
                if (scope.value && moment.isMoment(scope.value)) {
                    scope._value.month = scope.months.find(m => m.month() === scope.value.month());

                    _monthWatcher(scope._value.month);

                    if (scope.days) {
                        scope._value.day = scope.days.find(m => m.date() === scope.value.date());
                    }

                    scope._value.year = scope.value.year();
                } else {
                    scope._value = {
                        month: null,
                        day: null,
                        year: now.year(),
                    };
                }
            }

            function _valueWatcher(_value) {
                if (!scope.hasInteracted) {
                    return;
                }

                if (!scope.isYearRecurring && !_value.year) {
                    return (scope.value = null);
                }

                const day = _value.day?.date();
                const month = _value.month?.month();
                const year = _value.year;

                scope.value = moment
                    .utc({
                        day,
                        month,
                        year,
                    })
                    .startOf('day');
            }

            function _monthWatcher(month) {
                if (moment.isMoment(month)) {
                    scope.days = days(month);

                    if (scope._value.day) {
                        const date = scope._value.day.date() - 1;

                        scope._value.day = scope.days[Math.min(date, scope.days.length - 1)];
                    }
                } else {
                    scope.days = null;
                }
            }
        },
    };
}

let _months = null;
const _days = new Map();

function months() {
    if (_months) {
        return _months;
    }

    _months = Array.from(new Array(12)).map(function (_, i) {
        return moment()
            .month(i)
            .startOf('month');
    });

    return _months;
}

function days(month) {
    if (_days.has(month)) {
        return _days.get(month);
    }

    const days = Array.from(new Array(month.daysInMonth()))
        .map(function (_, i) {
            return month
                .clone()
                .date(i + 1)
                .startOf('day');
        })
        .sort((a, b) => a - b);

    _days.set(month, days);

    return _days.get(month);
}
